import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const socialLinks = [
  { name: "LinkedIn", icon: "Linkedin", url: "https://www.linkedin.com/company/thepseu/" }];


  const quickLinks = [
  { label: "Home", path: "/home-page" },
  { label: "Newsletter Archive", path: "/newsletter-archive" },
  { label: "About Us", path: "/home-page" },
  { label: "Contact", path: "/home-page" }];


  const legalLinks = [
  { label: "Privacy Policy", path: "/home-page" },
  { label: "Terms of Service", path: "/home-page" },
  { label: "Cookie Policy", path: "/home-page" }];


  return (
    <footer className="bg-card border-t border-border">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-12">
          <div className="lg:col-span-2">
            <Link to="/home-page" className="flex items-center gap-3 mb-4">
              <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
                <Icon name="Newspaper" size={24} color="var(--color-primary)" />
              </div>
              <span className="text-xl font-heading font-semibold text-foreground">
                THEPS Newsletter
              </span>
            </Link>

            <p className="text-sm text-muted-foreground leading-relaxed mb-6 max-w-md">
              THEPS Newsletter delivers weekly funding opportunities, national agency data, and expert project-writing tips to researchers and professionals. Stay informed about the latest grants, trends, and strategies to advance your research career.
            </p>

            <div className="flex items-center gap-3">
              {socialLinks?.map((social) =>
              <a
                key={social?.name}
                href={social?.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 bg-muted hover:bg-primary hover:text-primary-foreground text-muted-foreground rounded-lg transition-all duration-250"
                aria-label={`Visit our ${social?.name} page`}>

                  <Icon name={social?.icon} size={18} />
                </a>
              )}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-foreground uppercase tracking-wider mb-4">
              Quick Links
            </h3>
            <ul className="space-y-3">
              {quickLinks?.map((link) =>
              <li key={link?.label}>
                  <Link
                  to={link?.path}
                  className="text-sm text-muted-foreground hover:text-primary transition-colors duration-250">

                    {link?.label}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-foreground uppercase tracking-wider mb-4">
              Legal
            </h3>
            <ul className="space-y-3">
              {legalLinks?.map((link) =>
              <li key={link?.label}>
                  <Link
                  to={link?.path}
                  className="text-sm text-muted-foreground hover:text-primary transition-colors duration-250">

                    {link?.label}
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-muted-foreground text-center md:text-left">
              &copy; {currentYear} THEPS Newsletter. All rights reserved.
            </p>

            <div className="flex items-center gap-6 text-sm text-muted-foreground">
              <a
                href="mailto:contact@theps.org"
                className="hover:text-primary transition-colors duration-250 flex items-center gap-2">

                <Icon name="Mail" size={16} />
                <span>hello@theps.eu</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;